import { facilityBaseModel } from './crud';

export * from './types';
export const facilityModelKeys = facilityBaseModel.keys;

export const useFacilityById = facilityBaseModel.fetchById();
export const useFacilityByIds = facilityBaseModel.fetchByIds();
export const useFacilityMany = facilityBaseModel.fetchMany();
export const useFacilityCount = facilityBaseModel.count();
export const useFacilityUpdateOne = facilityBaseModel.edit();
export const useFacilityCreateOne = facilityBaseModel.create();
export const useFacilityRemoveOne = facilityBaseModel.delete();
export const useFacilityRemoveByIds = facilityBaseModel.deleteByIds();
export const useFacilityManyInfiniteQuery = facilityBaseModel.fetchPaginated();

export const useFacilityByIdV2 = facilityBaseModel.fetchByIdV2();
export const useFacilityByIdsV2 = facilityBaseModel.fetchByIdsV2();
export const useFacilityManyV2 = facilityBaseModel.fetchManyV2();
export const useFacilityCountV2 = facilityBaseModel.countV2();
export const useFacilityUpdateOneV2 = facilityBaseModel.editV2();
export const useFacilityCreateOneV2 = facilityBaseModel.createV2();
export const useFacilityRemoveOneV2 = facilityBaseModel.deleteV2();
export const useFacilityRemoveByIdsV2 = facilityBaseModel.deleteByIdsV2();
export const useFacilityManyInfiniteQueryV2 =
  facilityBaseModel.fetchPaginatedV2();

export const useFacilityPagination = facilityBaseModel.fetchPaginated();
export const useFacilityPaginationV2 = facilityBaseModel.fetchPaginatedV2();
export const useFacilityManyByContentRangeV2 =
  facilityBaseModel.fetchManyByContentRangeV2();
